import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import draggable from 'vuedraggable';
export default {
  name: 'common_nav_config',
  props: {
    disabled: Boolean,
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    menuList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  components: {
    draggable: draggable
  },
  data: function data() {
    return {
      defaultValue: {
        name: '',
        id: '',
        menus_type: '',
        show_type: '2',
        // 展示样式 1-图片视图 2-列表视图(默认),
        sort: '1'
      },
      typeList: [{
        label: '列表视图',
        id: '2',
        image_url: 'https://res.youlianfuwu.com/mini_program/shop/goods_nav_show_list.jpg'
      }, {
        label: '图片视图',
        id: '1',
        image_url: 'https://res.youlianfuwu.com/mini_program/shop/goods_nav_show_pic.png'
      }]
    };
  },
  methods: {
    changeMenu: function changeMenu(menu_ids, item) {
      var _menu_ids = _slicedToArray(menu_ids, 1),
        _menu_ids$ = _menu_ids[0],
        firstMenuId = _menu_ids$ === void 0 ? '' : _menu_ids$;
      var _ref = this.menuListFilter.find(function (i) {
          return i.id === firstMenuId;
        }) || {},
        _ref$type = _ref.type,
        type = _ref$type === void 0 ? '' : _ref$type;
      item.menus_type = type;
    },
    addBox: function addBox() {
      this.value.config.value.push(_objectSpread(_objectSpread({}, this.defaultValue), {}, {
        name: "\u5206\u7C7B".concat(this.value.config.value.length + 1)
      }));
    },
    onDelete: function onDelete(index) {
      var _this = this;
      this.$confirm("\u786E\u5B9A\u8981\u5220\u9664\u5206\u7C7B".concat(index + 1, "\u5417"), '提示', {
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(function () {
        _this.value.config.value.splice(index, 1);
      }).catch(function () {});
    }
  },
  created: function created() {
    var _this2 = this;
    this.$set(this.value, 'config', _objectSpread({
      margin_top: 15,
      z_index: 2,
      number: 20,
      value: Array.from({
        length: 3
      }, function (_, index) {
        return _objectSpread(_objectSpread({}, _this2.defaultValue), {}, {
          name: "\u5206\u7C7B".concat(index + 1)
        });
      })
    }, this.value.config));
  },
  computed: {
    menuListFilter: function menuListFilter() {
      return this.menuList.filter(function (i) {
        return ['cake',
        //蛋糕到家
        'new_cake',
        //蛋糕到家
        'cake_store',
        //蛋糕到店
        'code',
        //券码
        'entity',
        //实体
        'new_entity' //实体
        ].includes(i.type);
      });
    }
  }
};